import { get, post, postJson } from '../tools/async-tool'
// import { Message } from 'element-ui';
// function showErr(err) {
//   // 请求取消
//   // alert(JSON.stringify(err));
//   // console.log(err);
//   // console.log(!!(err.status.match(/canceled/i)), err);
//   if(typeof err.status == 'number' && (err.status == 0)) { return false; }
//   Message({
//     type: 'error',
//     message: err.body.error ? err.body.error : default_err,
//     customClass: 'manban-toast__error'
//   });
// }

export function getAccessToken (params, headers) {
  let url = '/aliyun/oss/sts'

  const outerHeaders = Object.assign({}, headers)

  return get(url, params, { headers: outerHeaders })
}
